import React, { FunctionComponent } from "react";
import HeroUnit from "./HeroUnit";
import ProductInfo from "./ProductInfo";
import Page from "../../shared/components/Page";
import SiteFooter from "../../shared/views/SiteFooter";
import ScrollToTopOnMount from "../../shared/components/ScrollToTopOnMount";
import StayInTouch from "../../shared/views/StayInTouch";

const Product: FunctionComponent = (props) => {
  return (
    <Page title="Web Field Guide">
      <ScrollToTopOnMount />
      <HeroUnit />
      <ProductInfo />
      <StayInTouch />
      <SiteFooter />
    </Page>
  );
};

export default Product;
